import type { NuxtUseScriptInput, NuxtUseScriptOptions } from "#nuxt-scripts";

export function useExponeaScript(
    scriptSource: string,
    scriptOptions?: NuxtUseScriptOptions
) {
  if (!import.meta.client) return;

  const authStore = useAuthStore();
  const { user, guest } = storeToRefs(authStore);

  const customerId = ref(null);

  customerId.value = user.value?.id ? user.value.id : guest.value?.id ? guest.value.id : null;

  const baseConfig: NuxtUseScriptInput = {
    src: scriptSource,
    id: "exponea-script",
  };

  if (customerId.value) baseConfig["data-customer-id"] = customerId.value;

  const exponeaScript = useScript(baseConfig, scriptOptions);

  return exponeaScript;
}
